// extracted by css-extract-rspack-plugin
export default {"viewer":"src-widgets-OpenSeadragon-module__viewer-L_bS58"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"viewer\":\"src-widgets-OpenSeadragon-module__viewer-L_bS58\"}";
        // 1793732399148
        var cssReload = require("../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  